import { useState } from "react"

export const UBRState = () => {
    const [pretest, setPretest ] = useState([]);
    const [modalCongrats, setModalCongrats ] = useState(false);
    const [modalWelcome, setModalWelcome ] = useState(false);
    const [open, setOpen ] = useState(false);
    const [openTrainings, setOpenTrainings ] = useState(false);

    const [isSteps, setIsSteps] = useState(
        [
            {selector:'.first-step' , name:'Trainings', desc:'Explore available trainings and start your extraordinary learning journey!', content:[]},
        ]
    );
    const [isMaintenance, setIsMaintenance] = useState(false)
   
    return {
        pretest: {data: pretest, set: setPretest},
        mc: {data: modalCongrats, set: setModalCongrats},
        mw: {data: modalWelcome, set: setModalWelcome},
        open: {data: open, set: setOpen},
        openT: {data: openTrainings, set: setOpenTrainings},
        isSteps: {data: isSteps, set: setIsSteps},
        mnt: {data: isMaintenance, set: setIsMaintenance},
    }
}